export default {
  name: 'transaction_customer_business_vat',
  component_path: 'modules/procedures/blocks/BlockInputText'
}